import { create } from 'zustand';
import type { UserInfo } from '@/types/AceIdentity';

interface IdentityStore {
  userInfo?: UserInfo;
  setUserInfo: (userInfo: UserInfo) => void;
}

const useIdentityStore = create<IdentityStore>((set) => ({
  userInfo: undefined,
  setUserInfo: (userInfo) => set({ userInfo }),
}));

export default useIdentityStore;
